// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__K43l3","content":"Section_content__2__1C","isOdd":"Section_isOdd__oyzYt","contentWrapper":"Section_contentWrapper__peN0V","action":"Section_action__lirS7"};